<template>
  <section>
    <page-header
      :page="page"
      has-return
      left-side-class="col-xl-8"
      right-side-class="col-xl-4 d-flex align-items-end justify-content-end pb-2"
    />
    <div class="row mb-3">
      <div class="col-12">
        <custom-separator text="Historial" />
      </div>
    </div>
    <board :details="details" />
    <template v-if="studentEvaluationHistory.statuses.length > 0">
      <time-line class="mt-4">
        <time-line-item
          v-for="detail in studentEvaluationHistory.statuses"
          :icon="getIconItem(detail.referralStatusId)"
          :key="detail.id"
        >
          <template #date>
            <span class="font-14">{{ formatDate(detail.date) }}</span>
            <p class="font-12 font-weight-normal">
              {{ formatTime(detail.date) }}
            </p>
          </template>
          <div class="row">
            <div class="col-sm-6 col-md-3 px-5 balloon-container">
              <div class="balloon-fixed">
                <custom-balloon
                  class="mb-4"
                  :text="detail.referralStatus"
                  :background-color="getColor(detail.referralStatusId)"
                />
              </div>
            </div>
            <div class="col-sm-4 col-md-9">
              <div class="row">
                <div class="col-md col-sm-12">
                  <span class="body-2 text-gray">Realizado por:</span>
                  <p class="body-1">
                    {{ detail.createdBy }}
                  </p>
                </div>
                <div class="col-sm col-md">
                    <div class="col-md col-sm-12">
                      <span class="body-2 text-gray">Comentario:</span>
                      <p class="body-1">
                        {{ detail.comment | empty}}
                      </p>
                    </div>
                </div>
                  <div class="col-sm col-md" v-if="detail.documentId">
                      <div class="col-md col-sm-12">
                        <span class="body-2 text-gray">Nombre del Archivo:</span>
                        <p class="body-1">
                          {{ detail.documentName | empty}}
                        </p>
                      </div>
                  </div>
                  <div class="col-sm col-md" v-if="detail.documentId">
                      <div class="col-md col-sm-12">
                        <action-button
                          i="fas fa-file-download mr-n1 pr-1"
                          variant="success"
                          @click="onDownloadDocumentHandler(detail.documentId)"
                        />
                      </div>
                  </div>
              </div>
            </div>
          </div>
        </time-line-item>
      </time-line>
    </template>
    <template v-else>
      <custom-result-not-found text="No se encontró historial." />
    </template>
  </section>
</template>

<script>
import PageHeader from "PageHeader";
import CustomSeparator from "custom-separator";
import Board from "Board";
import { TimeLine, TimeLineItem } from "@quisit/mipe-timeline";
import CustomResultNotFound from "custom-result-not-found";
import CustomBalloon from "custom-balloon";
import studentEvaluationService from "@/modules/student-evaluation-request-managment/api.js";
import rpStatuses from "@/utils/constants/rp/rpStatuses";
import moment from "moment";
import ActionButton from 'ActionButton';
import peiServices from "@/services/pei/general";

export default {
  name: "EvaluationRequestHistory",
  components: {
    PageHeader,
    CustomSeparator,
    Board,
    TimeLine,
    TimeLineItem,
    CustomResultNotFound,
    CustomBalloon,
    ActionButton
  },
  data() {
    return {
      studentEvaluationHistory: {
        studentSieId: null,
        studentName: null,
        evaluationTypeName: null,
        disciplineName: null,
        statuses: []
      }
    };
  },
  computed: {
    page() {
      return {
        icon: "fas fa-user-tie",
        title: "Manejo de Coordinación a Evaluación",
        routes: [
          "Inicio",
          "Estudiante",
          "Manejo de Coordinación a Evaluación",
          "Historial"
        ]
      };
    },
    details() {
      return [
        [
          {
            label: "Estudiante:",
            icon: "fas fa-address-book",
            data: `${this.studentEvaluationHistory.studentSieId} - ${this.studentEvaluationHistory.studentName}`
          },
          {
            label: "Tipo de Evaluación:",
            icon: "fas fa-file-alt",
            data: this.studentEvaluationHistory.evaluationTypeName
          },
          {
            label: "Disciplina:",
            icon: "fas fa-clipboard-list",
            data: this.studentEvaluationHistory.disciplineName
          }
        ]
      ];
    },
    rpStatuses() {
      return rpStatuses;
    }
  },
  async mounted() {
    await this.loadHistory(this.$route.params.studentReferralId);
  },
  methods: {
    onDownloadDocumentHandler(documentId) {
      if (documentId) {
        peiServices.downloadDocumentByAttachmentId(documentId);
      }
    },

    async loadHistory(studentReferralId) {
      const {
        data
      } = await studentEvaluationService.getStudentEvaluationHistoryStatus(
        studentReferralId
      );
      this.studentEvaluationHistory = data;
    },
    getColor(referralStatusId) {
      switch (referralStatusId) {
        case rpStatuses.Nuevo:
          return "pink";
        case rpStatuses.Cita_Coordinada:
          return "green-light";
        case rpStatuses.Denegado:
          return "brown";
        case rpStatuses.Procesado:
          return "green-light";
        case rpStatuses.Aprobado:
        case rpStatuses.AprobadoDevueltoREMPRO:
          return "yellow";
        case rpStatuses.ReCoordinar_Cita:
          return "yellow";
        case rpStatuses.Referido_a_Remedio_Provisional:
          return "violet";
        case rpStatuses.Inactivo:
          return "brown";
        case rpStatuses.AprobadoEnRempro:
          return "violet";
        case rpStatuses.No_Vinculado_Devuelto_RemPro:
          return "pink";
      }
      return "gray";
    },
    getIconItem(status) {
      switch (status) {
        case rpStatuses.Denegado:
        case rpStatuses.Denegado_Estudiante_fue_Egresado:
        case rpStatuses.Inactivo:
          return "fas fa-file-minus";
        case rpStatuses.Nuevo:
        case rpStatuses.Cita_Coordinada:
        case rpStatuses.Procesado:
          return "fas fa-edit";
        case rpStatuses.Aprobado:
        case rpStatuses.Evaluado:
          return "fas fa-file-user";
        default:
          return "fas fa-edit";
      }
    },
    formatDate(date) {
      return moment(date)
        .locale("es")
        .format("DD/MMM/YYYY");
    },
    formatTime(value) {
      return moment(value).format("hh:mm A");
    }
  }
};
</script>

<style scoped>
.border-bottom-a {
  border-bottom: 1px solid #ff7058;
  cursor: pointer !important;
}

.balloon-fixed {
  width: 170px;
}

@media screen and (max-width: 1150px) {
  .balloon-container {
    margin-right: 1px;
  }
}

@media screen and (max-width: 375px) {
  .balloon-fixed {
    margin-left: -20px;
  }
}

@media screen and (max-width: 360px) {
  .balloon-fixed {
    width: 150px !important;
  }
}
</style>
